import React, { useState } from 'react'

import Icon from 'components/Icon'
import InfoCircleTooltip from 'components/InfoCircleTooltip'
import MenuItem from 'components/MenuItem'
import Select from 'components/Select'
import Typography from 'components/Typography'
import { useEventContext } from 'context/EventContext'
import useViewport from 'hooks/useViewport'

import { SORT_OPTIONS } from './constants'

import classes from './SortSelect.module.scss'

/** @type {import("./types").default} */
const SortSelect = ({ onSelect }) => {
  const [selectedValue, setSelectedValue] = useState(SORT_OPTIONS.SPONSORED)
  const { down, between } = useViewport()
  const { sendEvent } = useEventContext()

  const handleChange = inputValue => {
    onSelect(inputValue)
    setSelectedValue(inputValue)
    sendEvent({
      name: 'engagement_sort',
      engagementComponent: 'sort_best-products_list',
      engagementDetails: `sort-item_${inputValue}`,
      engagementDestination: 'sort_by-option',
    })
  }

  return (
    <div className={classes.root}>
      <InfoCircleTooltip
        className={classes.infoCircle}
        label={between('sm', 'md') ? 'Sort by' : undefined}
        title={
          <div className={classes.tooltipContent}>
            <span className={classes.tooltipTitle}> Sorting options</span>
            <span className={classes.tooltipItem}>
              <b>Highest rating:</b> Products are sorted based on the average overall rating by users.
            </span>
            <span className={classes.tooltipItem}>
              <b>Number of reviews:</b> Products are sorted based on the number of verified user reviews.
            </span>
            <span className={classes.tooltipItem}>
              <b>Sponsored:</b> Products are sorted based on whether the vendor pays us to receive web traffic.
              Sponsored status does not influence whether a product makes it onto the list. Sponsored products include a
              link-out icon that takes users to the provider’s site.
            </span>
          </div>
        }
      />
      <Select
        value={selectedValue}
        onChange={handleChange}
        className={classes.select}
        IconComponent={() => (
          <Icon className={classes.icon} icon={['fas', 'caret-down']} size={down('xs') ? '10' : '14'} />
        )}
      >
        <MenuItem value={SORT_OPTIONS.SPONSORED}>
          <Typography className={classes.ellipsis} variant={'body-xs'}>
            Sponsored
          </Typography>
        </MenuItem>
        <MenuItem value={SORT_OPTIONS.USER_RATING}>
          <Typography className={classes.ellipsis} variant={'body-xs'}>
            Highest rated
          </Typography>
        </MenuItem>
        <MenuItem value={SORT_OPTIONS.REVIEWS_COUNT}>
          <Typography className={classes.ellipsis} variant={'body-xs'}>
            N of reviews
          </Typography>
        </MenuItem>
      </Select>
    </div>
  )
}

export default SortSelect
